import { formatDateTime } from "core/utils/helper";
import { ANALYZE_TYPE } from "modules/Ingredients/constant";
import { useGoToAiChef } from "modules/AiChef/hooks/aiChef";
import { _t } from "core/language";

interface Item {
  id: string;
  files?: { url?: { medium: string } }[];
  name: string;
  analyze_type: keyof typeof ANALYZE_TYPE;
  ingredients: string;
  response_ingredients: any;
  response_meals: any;
  created_at: string;
  analyze_title: string;
}

export const convertArrayToString = (array: string[], length: number) => {
  const dataLimit = array.slice(0, length);
  const dot = array.length > length ? "..." : "";
  const str = dataLimit.map((item: any) => {
    //check item.translates has length > 0
    if (item?.translates.length === 0) return "";
    return `${item?.translates[0].name}, `;
  });
  const text = str.join(" ") + dot;
  //remove , at the end of string
  return text.replace(/,\s*$/, "");
};

// const convertArrayToStringMeal = (array: string[]) => {
//   const dataLimit = array.slice(0, 3);
//   const dot = array.length > 3 ? "..." : "";
//   const str = dataLimit.map((item: any) => {
//     //check item.translates has length > 0
//     return `${item?.name}, `;
//   });
//   const text = str.join(" ") + dot;
//   //remove , at the end of string
//   return text.replace(/,\s*$/, "");
// };

const Items = ({ item }: { item: Item }) => {
  const { goToAiChef } = useGoToAiChef();
  return (
    <div
      className=""
      onClick={() => {
        // searchParams.set("tab", "history");
        // setSearchParams(searchParams, { replace: true });
        goToAiChef(item);
      }}
    >
      <div
        key={item.id}
        className="flex justify-between items-center mt-[21px]"
      >
        <div className="min-w-[120px] max-w-[120px] h-[90px] mr-[6px]">
          <img
            src={item.files ? item.files[0].url?.medium : ""}
            alt={item.name}
            className="w-full h-full object-cover rounded-[6px]"
          />
        </div>
        <div className="flex flex-col justify-around h-[91px] w-[calc(100%-120px)]">
          <h2 className="text-[13px] font-bold text-[#111111]">
            {_t(ANALYZE_TYPE[item.analyze_type])}
          </h2>
          <p className="text-[13px] text-[#333333]">
            {item.analyze_type === "INGREDIENT" &&
              convertArrayToString(item.response_ingredients, 5)}
            {item.analyze_type === "MEAL" && `${item.analyze_title}`}
          </p>
          <span className="text-[11px] text-[#999999]">
            {formatDateTime(item.created_at, "YYYY.MM.DD HH:mm")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Items;
